const envs = {
  production: 'production',
  pdstaging: 'pdstaging',
  staging: 'staging',
  sandbox: 'sandbox',
  localhost: 'localhost'
}

export const conf = Object.freeze({
  envs,
  googleAnalyticsId: 'UA-8759953-1',
  segmentWriteKey: {
    production: 'FB4ey20k0M2TtO3QinG2R4QkPI4lEfHU',
    pdstaging: 'kVZtwA72zHIDU8EW3z7UXGatLpV2j1tY',
    development: 'kVZtwA72zHIDU8EW3z7UXGatLpV2j1tY'
  }
})